import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { TrackingConstant } from 'client/tracking/constant';
import { EventToolbox } from 'client/utils/event-toolbox';

export const usePrivacyChoiceTracking = () => {
  const doNotSell = useSelector(state => state?.visitor?.privacy?.doNotSell);

  useEffect(() => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        action_name: TrackingConstant.ACTION_FILL_FORM,
        creative_id: 'data-privacy',
        action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
        action_cause: TrackingConstant.PAGE_LOAD_CAUSE,
        subaction_name: 'data_privacy_request',
        value: doNotSell ? 'Opt out' : 'Opt in',
      },
    });
  }, [doNotSell]);
};
